import { api } from '@/lib/api';

export type InboundEmailStatus =
  | 'RECEIVED'
  | 'CLASSIFIED'
  | 'MATCHED'
  | 'PROCESSED'
  | 'REJECTED';

export interface InboundEmailDTO {
  id: string;
  userId: string | null;
  messageId: string;
  fromEmail: string;
  subject: string;
  receivedAt: string;
  rawGcsPath: string | null;
  attachmentPaths: string[];
  matchedFiscalRecordId: string | null;
  processingStatus: InboundEmailStatus;
  classificationConfidence: number | null;
  rejectionReason: string | null;
  createdAt: string;
}

export interface AssignInboxResponse {
  inboundEmail: InboundEmailDTO;
  fiscalRecordId: string;
}

export const inboxApi = {
  list: () => api.get<InboundEmailDTO[]>('/inbox'),
  assign: (emailId: string, serviceId: string) =>
    api.post<AssignInboxResponse>(`/inbox/${emailId}/assign`, { serviceId }),
};
